<template>
  <div class="menu-page">
    <!-- {{ caipiaoHallList }} -->
    <ul class="container">
      <li :class="{ active: isActive('/') }" @click="$goTo('/')">
        <span>首页</span>
        <!-- <i class="el-icon-arrow-down"></i> -->
      </li>
      <el-popover placement="bottom" trigger="hover" :visible-arrow="false" popper-class="el-popover-class-header-menu">
        <div class="lottery">
          <div class="container">
            <div class="item" v-for="item in caipiaoHallList" :key="item.id">
              <div class="left">
                <img class="icon-img" :src="item.image" />
                <span>{{ item.name }}</span>
              </div>
              <ul class="right">
                <li v-for="val in item.caipiaoList" :key="val.id" @click="$goTo('/synthesis?id=' + val.id)">
                  <span>{{ val.name }}</span>
                  <img class="tip-img" v-if="val.tag == 'hot'" :src="require(`@/assets/images/tip-hot.svg`)" />
                  <img class="tip-img" v-else-if="val.tag == 'new'" :src="require(`@/assets/images/tip-new.svg`)" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <li slot="reference" :class="{ active: isActive('/synthesis') }">
          <span>彩票大厅</span>
          <i class="el-icon-arrow-down"></i>
        </li>
      </el-popover>
      <li :class="{ active: isActive('/long') }" @click="$goTo('/long')">
        <span>长龙统计</span>
        <!-- <i class="el-icon-arrow-down"></i> -->
      </li>
    </ul>
  </div>
</template>

<script>
import { get, post } from '@/utils/request'
import apis from '@/utils/api'
export default {
  computed: {
    // 获取不带参数的路径
    basePath() {
      // console.log(this.$route)
      return this.$route.path
    },
  },
  data() {
    return {
      caipiaoHallList: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    isActive(path) {
      return path == this.basePath
    },
    getList() {
      get(apis.getCaipiaoHall, {}, {
        showLoading: false
      }).then(res => {
        // console.log(res, 111)
        this.caipiaoHallList = res.data
      })
    },
  },
}
</script>
<style scoped lang="scss">
.menu-page {
  background-color: #f84c4c;

  .container {
    display: flex;
    align-items: center;

    li {
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      color: #fff;
      font-size: 14px;
      padding: 0px 20px;

      &:hover {
        background-color: #dc2f2f;

        i {
          transform: rotate(180deg);
        }
      }

      &.active {
        background-color: #dc2f2f;
      }
    }
  }
}

.lottery {
  width: 100vw;
  max-height: 40vh;
  overflow-y: auto;

  .container {
    .item {
      display: flex;
      align-items: flex-start;
      gap: 10px;

      .left {
        display: flex;
        align-items: center;
        color: #333;
        font-size: 16px;
        width: 110px;
        gap: 5px;
        line-height: 36px;

        img {
          width: 18px;
          height: 18px;
        }
      }

      .right {
        border-bottom: 1px solid #ededed;
        padding-bottom: 5px;
        flex: 1;
        display: flex;
        flex-wrap: wrap;

        li {
          position: relative;
          margin-right: 30px;
          cursor: pointer;
          padding: 3px 0px;

          span {
            display: inline-block;
            line-height: 30px;
            padding: 0px 8px;

            &:hover {
              background-color: #ff5757;
              color: #fff;
              border-radius: 6px;
            }
          }


          img {
            position: absolute;
            width: 22px;
            height: 14px;
            right: -20px;
            top: -2px;
          }
        }
      }
    }
  }
}
</style>
